import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Img, LoopVideo, loopFor } from "./Media";
import { mediaUrl } from "@/lib/api";
import { catLabel } from "@/lib/api";

export function ProjectCard({ p, tall = false }) {
  return (
    <Link to={`/projects/${p.slug}`} className="ib-zoom group block" data-testid={`project-card-${p.slug}`}>
      <div className={`relative overflow-hidden ${tall ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
        <Img src={p.cover} alt={p.title} className="h-full w-full" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-80 transition-opacity group-hover:opacity-100" />
        <div className="absolute bottom-0 p-4 text-white">
          <p className="text-[0.68rem] uppercase tracking-[0.18em] text-white/80">{catLabel(p.category)}{p.location ? ` · ${p.location}` : ""}</p>
          <p className="font-display text-lg uppercase leading-tight">{p.title}</p>
        </div>
      </div>
    </Link>
  );
}

export function QuoteCta({ title = "Ready to build something great?", text = "Tell us about your project and request a free estimate.", label = "Get a Quote", to = "/contact" }) {
  return (
    <section className="ib-grain bg-[color:var(--ib-charcoal)] text-white" data-testid="quote-cta-section">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-5 py-14 md:flex-row md:items-center lg:px-8">
        <div>
          <h2 className="font-display text-3xl uppercase sm:text-4xl">{title}</h2>
          <p className="mt-2 text-white/70">{text}</p>
        </div>
        <Link to={to} className="ib-btn ib-btn-primary" data-testid="quote-cta-btn">{label} <ArrowRight size={16} /></Link>
      </div>
    </section>
  );
}

export function PageHero({ eyebrow, title, text, image }) {
  return (
    <section className="relative isolate overflow-hidden bg-[color:var(--ib-charcoal)]" data-testid="page-hero">
      {image && (loopFor(image)
        ? <LoopVideo src={loopFor(image)} poster={mediaUrl(image, "lg")} className="absolute inset-0 -z-10 h-full w-full object-cover opacity-45" testid="page-hero-video" />
        : <Img src={image} alt="" eager size="lg" className="absolute inset-0 -z-10 h-full w-full opacity-45" />)}
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:py-28 lg:px-8">
        {eyebrow && <p className="ib-eyebrow ib-reveal">{eyebrow}</p>}
        <h1 className="ib-reveal mt-3 max-w-3xl font-display text-4xl uppercase leading-[1.02] text-white sm:text-5xl lg:text-6xl">{title}</h1>
        {text && <p className="ib-reveal mt-5 max-w-xl text-base text-white/80 sm:text-lg" style={{ animationDelay: ".1s" }}>{text}</p>}
      </div>
    </section>
  );
}

export function Loading() {
  return <div className="flex min-h-[50vh] items-center justify-center" data-testid="loading"><div className="h-8 w-8 animate-spin rounded-full border-2 border-[color:var(--ib-orange)] border-t-transparent" /></div>;
}
